module.exports = __webpack_public_path__ + "img/05.17b96dde.jpg";